import { Reveal } from "@/components/Reveal";
import { JOTFORM_URL } from "@/constants";

const Contact = () => (
    <section
        id="contact"
        data-testid="contact-section"
        className="relative overflow-hidden px-6 py-32 sm:py-40 lg:px-16 lg:py-48"
    >
        <div className="royal-flare absolute inset-x-0 top-0 h-[55vh] opacity-70" />

        <div className="relative mx-auto max-w-3xl text-center">
            <Reveal>
                <p className="mb-8 font-display text-[10px] uppercase tracking-[0.5em] text-[#270057]">
                    Contact Us
                </p>
                <h2
                    data-testid="contact-title"
                    className="font-serif text-4xl font-normal leading-[1.1] tracking-[-0.01em] text-[#270057] sm:text-5xl lg:text-6xl"
                >
                    Begin the <em className="italic">Conversation</em>
                </h2>
                <div className="royal-rule mx-auto mt-12 w-32" />
                <p
                    data-testid="contact-copy"
                    className="mx-auto mt-10 max-w-xl text-base font-normal leading-relaxed text-[#270057] sm:text-lg"
                >
                    Every commission begins with a single inquiry. Share your
                    brief, your timeline, and your ambition — the atelier will
                    respond with structure.
                </p>
                <div className="mt-14">
                    <a
                        href={JOTFORM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-submit-inquiry-button"
                        className="btn-royal inline-block rounded-full px-12 py-5 font-display text-[11px] font-semibold uppercase tracking-[0.3em]"
                    >
                        Submit Project Inquiry
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Contact;
